/**
 * Resolve the current user's identity ids used for assignee / "Waiting on me".
 * Cognito login stores `userSub`; Dynamo profile may expose `cognitoId` / `id`
 * (legacy rows can have id ≠ cognitoId). Prefer Cognito sub for matching.
 * Optionally merges firm Users / teamFilter rows whose email matches the profile,
 * so "Assigned to Jonathan" and "Waiting on me" use the same Cognito id set.
 *
 * @param {object|null|undefined} profileDetails — state.profile.details
 * @param {Array<{ ownerUserId?: string|null, sub?: string|null, email?: string|null }>|null|undefined} [colleagues]
 * @returns {{ primary: string|null, all: string[] }}
 */
export const resolveCurrentUserIds = (profileDetails, colleagues) => {
  if (!profileDetails) return { primary: null, all: [] };
  const candidates = [
    profileDetails.userSub,
    profileDetails.sub,
    profileDetails.cognitoId,
    profileDetails.userId,
    // Last: Dynamo profile id — only useful when it equals the Cognito sub.
    profileDetails.id,
  ]
    .map((v) => (v == null ? '' : String(v).trim()))
    .filter((v) => v && v !== 'false' && v !== 'null' && v !== 'undefined');

  const myEmail = String(profileDetails.email || '')
    .trim()
    .toLowerCase();
  if (myEmail && Array.isArray(colleagues)) {
    colleagues.forEach((m) => {
      const email = String(m?.email || '')
        .trim()
        .toLowerCase();
      const id = String(m?.sub || m?.ownerUserId || '').trim();
      if (email && id && email === myEmail) candidates.push(id);
    });
  }

  const all = [...new Set(candidates)];
  return { primary: all[0] || null, all };
};

/**
 * @param {string|null|undefined} assigneeUserId
 * @param {string[]} myIds
 * @returns {boolean}
 */
export const isAssignedToCurrentUser = (assigneeUserId, myIds) => {
  if (!assigneeUserId || !myIds?.length) return false;
  const target = String(assigneeUserId);
  return myIds.some((id) => String(id) === target);
};
